import React from "react";
import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";

export default function VariantPicker({ variants = [], value, onChange }) {
  if (!Array.isArray(variants) || variants.length <= 1) return null;

  return (
    <Box sx={{ mt: 1 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 0.5, display: "block" }}>
        Variant
      </Typography>

      <ToggleButtonGroup
        exclusive
        value={value}
        onChange={(_, v) => v && onChange?.(v)}
        size="small"
        sx={{ flexWrap: "wrap" }}>
        {variants.map((v) => (
          <ToggleButton
            key={v.id}
            value={v.id}
            sx={{
              px: 1.25,
              "&.Mui-selected": {
                bgcolor: (t) => t.palette.secondary.main,
                color: (t) => t.palette.text.secondary,
              },
            }}>
            {v.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}
